import React from "react";
import { useState, useRef, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { toast } from "react-toastify";
import NotesComp from "../../Components/createTicket/NotesComp";
import RadioButton from "../../Components/createTicket/RadioButton";
import DescribeBox from "../../Components/createTicket/DescribeBox";
import HeadingTop from "../../Components/createTicket/HeadingTop";
import SelectDropdown from "../../Components/createTicket/SelectDropdown";
import InputField from "../../Components/createTicket/InputField";
import CreateButton from "../../Components/createTicket/CreateButton";
import BrowesFileBox from "../../Components/createTicket/BrowesFileBox";
import CreateTicketRemittence from "./CreateTicketRemittence";
import CreateTicketTransferMyAmount from "./CreateTicketTransferMyAmount";
import CreateTicketRechargingWallet from "./CreateTicketRechargingWallet";
import CreateTicketKYC from "./CreateTicketKYC";
import CreateTicketChannel from "./CreateTicketChannel";
import CreateTicketAccountLedger from "./CreateTicketAccountLedger";
import CreateTicketTDSForm from "./CreateTicketTDSForm";
import CreateTicketIssueWithInvoice from "./CreateTicketIssueWithInvoice";
import CreateTicketWithGST from "./CreateTicketWithGST";
import CreateTicketRequestClaim from "./CreateTicketRequestClaim";
import CreateTicketIssueWithEngageService from "./CreateTicketIssueWithEngageService";
import WrongPackageDelivered from "./WrongPackageDelivered";
import DeliveryNotRecived from "./DeliveryNotRecived";
import ReactSelect from "react-select";
import makeAnimated from "react-select/animated";

const apiUrl = process.env.REACT_APP_URL;
const Token = localStorage.getItem("_ux98c_v1");

const animatedComponents = makeAnimated();

const classes = {
  hr: {
    marginTop: "12px",
    marginBottom: "10px",
    border: "none",
    borderBottom: "1px solid #000", // Border-bottom style with 2px width
  },
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", // Background color of the control
    borderColor: state.isFocused ? "#2684FF" : "#ccc", // Border color when focused or not
    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : null, // Box shadow when focused
    "&:hover": {
      borderColor: "#2684FF", // Border color on hover
    },
    padding: "0px",
    // Padding inside the control
  }),
  menu: (provided) => ({
    ...provided,
    width: "100%",
    backgroundColor: "#fff", // Background color of the dropdown menu
    // Rounded corners for the dropdown menu
    zIndex: 999, // Ensure it appears above other elements
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
        ? "#f0f0f0"
        : "#fff", // Background color for selected and focused options
    color: state.isSelected ? "#fff" : "#333", // Text color
    padding: "5px", // Padding inside each option
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333", // Color of the selected value
    fontWeight: "bold", // Bold text for selected value
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999", // Color of the placeholder text
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#2684FF" : "#ccc", // Color of the dropdown indicator (arrow)
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#2684FF" : "#ccc", // Color of the clear indicator (X)
  }),
};

const style = {
  top: 0,
  right: 0,
  margin: "auto",
  width: "60%",
  height: "95%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  transition: "transform 0.5s ease-in-out",
  borderRadius: "10px",
  // alignItems: "center",
  marginBottom: "20px",
  marginTop: "20px",
};

const openStyle = {
  transform: "translateX(0)",
};

function CreateTicket({ customerId }) {
  const dropdownRef = useRef(null);
  const [issueOption1, setIssueOption1] = useState([]);
  const [issueOption2, setIssueOption2] = useState([]);
  const [issueOption3, setIssueOption3] = useState([]);
  const [issueOption4, setIssueOption4] = useState([]);
  const [issueOption5, setIssueOption5] = useState([]);
  const [issueOption6, setIssueOption6] = useState([]);
  const [issueOption7, setIssueOption7] = useState([]);
  const [issueOption8, setIssueOption8] = useState([]);
  const [issueOption9, setIssueOption9] = useState([]);
  const [trigger, setTrigger] = useState(false);
  const [open, setOpen] = useState(false);
  const [awbNumber, setAwbNumber] = useState("");
  const [caseList, setCaseList] = useState([]);
  const [caseSubType, setCaseSubType] = useState([]);
  const [caseId, setCaseId] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedValue4, setSelectedValue4] = useState("");
  const [selectedValue4Id, setSelectedValue4Id] = useState("");
  const [selectedValue3, setSelectedValue3] = useState("");
  const [selectedValue, setSelectedValue] = useState("Single AWB");
  const [description, setDescription] = useState("");
  const [selectedItems, setSelectedItems] = useState("");
  const [assignedEmployeeId, setAssignedEmployeeId] = useState("");
  const [employeeDepartment, setEmployeeDepartment] = useState([]);
  const [department, setDepartment] = useState([]);
  const [selectDepartment, setSelectDepartment] = useState("");
  const fileInputRef = useRef(null);
  const [childSubmitHandler, setChildSubmitHandler] = useState(null);
  // console.log(customerId);
  const handleOpen = () => {
    setOpen(true);
    setTrigger(true);
  };
  const handleClose = () => setOpen(false);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleInputValueDescription = (event) => {
    setDescription(event.target.value);
    // console.log(event.target.value);
  };
  const handleDeleteFile = () => {
    setSelectedFile(null);
  };

  const handleChange3 = (event) => {
    // console.log(event);
    setCaseId(event.id);
    setSelectedValue3(event.name);
  };
  const handleChange4 = (event) => {
    setSelectedValue4Id(event.id);

    setSelectedValue4(event.name);
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    // console.log(event.target.value);
  };

  const handleInputValue = (event) => {
    setAwbNumber(event.target.value);
  };
  const isSingleAWB = selectedValue === "Single AWB";
  const isMultipleAWBs = selectedValue === "Multiple AWBs";

  const isValidSelectedValue = (value) => {
    const invalidValues = [
      10, 11, 12, 13, 14, 18, 19, 20, 21, 23, 24, 25, 26, 30, 33, 34, 32, 35,
      36, 39, 40, 41, 42,
    ];
    return !invalidValues.includes(value);
  };

  const departmentOptions = department.map((dept) => ({
    label: dept.name,
    value: dept.id,
  }));
  const employeeOptions = employeeDepartment.map((dept) => ({
    label: dept.name,
    value: dept.id,
  }));

  const handleDepartmentAssign1 = (option) => {
    const selectedLabels = option.map((options) => options.label);
    // console.log("Selected Labels:", selectedLabels);
    setSelectDepartment(selectedLabels);
  };

  const handleCheckboxChangeAssign = (option) => {
    const selectedLabels = option.map((options) => options.value);
    // console.log("Selected Labels:", option);
    setSelectedItems(selectedLabels);
  };

  const handleCreateCase = async (event) => {
    event.preventDefault();
    if (!caseId) {
      toast.error("Please select a Category.");
      return;
    }

    // 2. Subcategory validation
    if (!selectedValue4Id) {
      toast.error("Please select a Subcategory.");
      return;
    }

    // 3. Remarks validation
    if (!description.trim()) {
      toast.error("Remarks are required.");
      return;
    }

    // 4. AWB validation only when AWB input is applicable
    if (
      isValidSelectedValue(Number(selectedValue4Id)) &&
      !awbNumber.trim() &&
      !selectedFile
    ) {
      toast.error("Please enter AWB number or upload an Excel file.");
      return;
    }
    const formData = new FormData();
    formData.append("caseType", caseId);
    formData.append("caseSubType", selectedValue4Id);
    formData.append("isMultipleAWB", !isSingleAWB);
    formData.append("awbNo", awbNumber);
    formData.append("isExcel", selectedFile ? true : isSingleAWB);
    formData.append("awbExcel", selectedFile);
    formData.append("empIds", selectedItems);
    formData.append("discriptionIssue", description);
    try {
      const response = await fetch(
        `${apiUrl}/caseM/addCaseAuth?customerId=${customerId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          body: formData,
        },
      );

      if (response.ok) {
        toast.success("Case Created successfully!");
        setOpen(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        toast.error("Failed to create case. Please try again.");
      }
    } catch (error) {
      toast.error("Failed to create case. Please try again.");
    }
  };

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/7`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          // setLeadSourceOptions(data.data);
          setDepartment(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);

  // useEffect(() => {
  //   fetch(`${apiUrl}/employee/allEmpDesig?department=${selectDepartment}`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Bearer ${Token}`,
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.data && Array.isArray(data.data)) {
  //         setEmployeeDepartment(data.data);
  //       } else {
  //         console.error(
  //           "API response is not in the expected format for countries.",
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching country data:", error);
  //     });
  // }, [selectDepartment]);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/26`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption1(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/29`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption2(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/30`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption3(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/31`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption4(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/32`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption5(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/33`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption6(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/37`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption7(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/38`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption8(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);
  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/36`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setIssueOption9(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/caseMaster/getCaseType`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          if (Array.isArray(data.data)) {
            setCaseList(data.data);
          } else {
            console.error("API response does not contain users array:", data);
          }
        } else {
          console.error("API request was not successful:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [trigger]);

  //console.log(caseList);

  useEffect(() => {
    const Token = localStorage.getItem("_ux98c_v1");

    fetch(`${apiUrl}/caseMaster/getAllCaseSubType/${caseId}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          if (Array.isArray(data.data)) {
            setCaseSubType(data.data);
          } else {
            console.error("API response does not contain users array:", data);
          }
        } else {
          console.error("API request was not successful:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [caseId]);
  // console.log(caseSubType);
  return (
    <div>
      <a
        onClick={handleOpen}
        className="btn btn-danger btn-xs w-100 mb-1 mt-1"
        style={{ color: "#fff" }}
      >
        Add New Case
      </a>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={{ ...style, ...(open && openStyle) }}
            className="overflow-auto"
          >
            <HeadingTop handleClose={handleClose}></HeadingTop>
            <hr style={classes.hr} />
            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
              <SelectDropdown
                dropDownData={caseList}
                handleChange={handleChange3}
                selectedData={selectedValue3}
                Text={"Select Category"}
              ></SelectDropdown>
              <SelectDropdown
                dropDownData={caseSubType.filter(
                  (item) => item.name !== "Email case",
                )}
                handleChange={handleChange4}
                selectedData={selectedValue4}
                Text={"Select Subcategory"}
              ></SelectDropdown>
            </Box>

            <>
              {isValidSelectedValue(selectedValue4Id) && (
                <Box>
                  <RadioButton
                    handleChange={handleChange}
                    selectedValue={selectedValue}
                  />
                </Box>
              )}
              {isSingleAWB && isValidSelectedValue(selectedValue4Id) && (
                <Box className="mt-3">
                  <InputField
                    text="AWB(s) e.g: 10912581234"
                    handleInputValue={handleInputValue}
                    value={awbNumber}
                  />
                </Box>
              )}
            </>
            {isMultipleAWBs && isValidSelectedValue(selectedValue4Id) && (
              <Box className="mt-3 ">
                <InputField
                  text="Enter comma-separated values or press enter,"
                  handleInputValue={handleInputValue}
                  value={awbNumber}
                ></InputField>
                <NotesComp
                  text={
                    " You can add up to 50 AWBs here. To add more AWBs, please upload sheet. "
                  }
                ></NotesComp>
                <BrowesFileBox
                  handleDeleteFile={handleDeleteFile}
                  handleFileChange={handleFileChange}
                  selectedFile={selectedFile}
                  text={"Upload your AWB(s)"}
                  url={`${apiUrl}/uploads/awbExcel.xlsx`}
                ></BrowesFileBox>
              </Box>
            )}
            {selectedValue4Id == 10 && (
              <CreateTicketRemittence
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                customerId={customerId}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketRemittence>
            )}
            {selectedValue4Id == 11 && (
              <CreateTicketTransferMyAmount
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketTransferMyAmount>
            )}
            {selectedValue4Id == 12 && (
              <CreateTicketRechargingWallet
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleShow={true}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketRechargingWallet>
            )}
            {selectedValue4Id == 13 && (
              <CreateTicketRechargingWallet
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleShow={false}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketRechargingWallet>
            )}
            {selectedValue4Id == 14 && (
              <CreateTicketRechargingWallet
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleShow={"Hide"}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketRechargingWallet>
            )}
            {(selectedValue4Id == 18 ||
              selectedValue4Id == 39 ||
              selectedValue4Id == 40) && (
              <CreateTicketKYC
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketKYC>
            )}
            {/* {selectedValue4Id == 19 && (
              <p className="mt-3 fw-bold fs-12">
                Congratulations! Your bank details have been verified
                successfully on 13 October 2022.
              </p>
            )} */}

            {selectedValue4Id == 20 && (
              <>
                <CreateTicketChannel
                  customerId={customerId}
                  caseId={caseId}
                  setOpen={setOpen}
                  selectedValue4Id={selectedValue4Id}
                  selectedData={selectedValue4Id}
                  optionData1={issueOption1}
                  optionData2={issueOption2}
                  text={"Enter Order ID(s) here (optional)"}
                  handleClose={handleClose}
                  departmentOptions={departmentOptions}
                  employeeOptions={employeeOptions}
                  handleDepartmentAssign1={handleDepartmentAssign1}
                  handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                  customStyles={customStyles}
                  selectedItems={selectedItems}
                  description={description}
                onRegisterSubmit={setChildSubmitHandler}
                ></CreateTicketChannel>
              </>
            )}
            {selectedValue4Id == 21 && (
              <CreateTicketChannel
                customerId={customerId}
                caseId={caseId}
                setOpen={setOpen}
                selectedValue4Id={selectedValue4Id}
                selectedData={selectedValue4Id}
                optionData1={issueOption3}
                optionData2={issueOption4}
                text={"Add your order ID and press Enter"}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketChannel>
            )}
            {selectedValue4Id == 23 && (
              <CreateTicketAccountLedger
                customerId={customerId}
                caseId={caseId}
                setOpen={setOpen}
                selectedValue4Id={selectedValue4Id}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketAccountLedger>
            )}
            {selectedValue4Id == 24 && (
              <CreateTicketTDSForm
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketTDSForm>
            )}
            {selectedValue4Id == 25 && (
              <CreateTicketIssueWithInvoice
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketIssueWithInvoice>
            )}
            {selectedValue4Id == 26 && (
              <CreateTicketWithGST
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                customerId={customerId}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketWithGST>
            )}
            {selectedValue4Id == 29 && (
              <CreateTicketRequestClaim
                // text={"Describes your issue:"}
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                // description={description}
                handleInputValueDescription={handleInputValueDescription}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketRequestClaim>
            )}
            {selectedValue4Id == 30 && (
              <CreateTicketRequestClaim
                text={"Select Issue"}
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketRequestClaim>
            )}
            {selectedValue4Id == 42 && (
              <WrongPackageDelivered
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></WrongPackageDelivered>
            )}
            {selectedValue4Id == 41 && (
              <DeliveryNotRecived
                customerId={customerId}
                caseId={caseId}
                selectedValue4Id={selectedValue4Id}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></DeliveryNotRecived>
            )}
            {/* {(selectedValue4Id == 33 || selectedValue4Id == 34) && (
              <NotesComp
                text={
                  "You are not currently using our Fship Fulfillment services. Please raise your issue under Others>>My Issue Not Listed subcategory."
                }
              ></NotesComp>
            )} */}

            {(selectedValue4Id == 32 ||
              selectedValue4Id == 35 ||
              selectedValue4Id == 33 ||
              selectedValue4Id == 36 ||
              selectedValue4Id == 34) && (
              <CreateTicketIssueWithEngageService
                selectedValue4Id={selectedValue4Id}
                optionData1={issueOption5}
                optionData2={issueOption6}
                optionData3={issueOption7}
                optionData4={issueOption8}
                optionData5={issueOption9}
                customerId={customerId}
                caseId={caseId}
                setOpen={setOpen}
                handleClose={handleClose}
                departmentOptions={departmentOptions}
                employeeOptions={employeeOptions}
                handleDepartmentAssign1={handleDepartmentAssign1}
                handleCheckboxChangeAssign={handleCheckboxChangeAssign}
                customStyles={customStyles}
                selectedItems={selectedItems}
                 description={description}
                onRegisterSubmit={setChildSubmitHandler}
              ></CreateTicketIssueWithEngageService>
            )}

            {/* ADD REMARKS HERE */}
            <Box className="mt-3">
              <label
                className="form-label fw-bold"
                style={{ fontSize: "12px" }}
              >
                Remarks
              </label>

              <textarea
                className="form-control"
                rows="3"
                value={description}
                onChange={handleInputValueDescription}
                placeholder="Enter remarks"
                required
              />
            </Box>

            {(selectedValue4Id == 41 || selectedValue4Id == 42 || selectedValue4Id == 10 || selectedValue4Id == 11 || selectedValue4Id == 12 || selectedValue4Id == 13 || selectedValue4Id == 14
              || selectedValue4Id == 18 || selectedValue4Id == 39 || selectedValue4Id == 40 || selectedValue4Id == 20 || selectedValue4Id == 20 ||  selectedValue4Id == 21 || selectedValue4Id == 23 
              || selectedValue4Id == 24  || selectedValue4Id == 25 || selectedValue4Id == 26 || selectedValue4Id == 29 ||  selectedValue4Id == 29 ||  selectedValue4Id == 19 || selectedValue4Id == 30 || selectedValue4Id == 31 || selectedValue4Id == 32 ||
             selectedValue4Id == 33 ||  selectedValue4Id == 34 || selectedValue4Id == 35 || selectedValue4Id == 36 || selectedValue4Id == 41 || selectedValue4Id == 42 || selectedValue4Id == 40 || selectedValue4Id == 26
            )
               && (
              <Box>
                <CreateButton
                  type="button"
                  handleClose={handleClose}
                  handleCreateCase={childSubmitHandler}
                />
              </Box>
            )}

            {/* <Box
            //className="col-md-6"
            // style={{ width: "100%" }}
            >
              {selectedValue4Id !== 10 &&
                selectedValue4Id !== 11 &&
                selectedValue4Id !== 19 &&
                selectedValue4Id !== 12 &&
                selectedValue4Id !== 13 &&
                selectedValue4Id !== 14 &&
                selectedValue4Id !== 18 &&
                selectedValue4Id !== 39 &&
                selectedValue4Id !== 20 &&
                selectedValue4Id !== 21 &&
                selectedValue4Id !== 23 &&
                selectedValue4Id !== 24 &&
                selectedValue4Id !== 25 &&
                selectedValue4Id !== 26 &&
                // selectedValue4Id !== 29 &&
                selectedValue4Id !== 30 &&
                // selectedValue4Id !== 31 &&
                selectedValue4Id !== 32 &&
                selectedValue4Id !== 35 &&
                selectedValue4Id !== 33 &&
                selectedValue4Id !== 34 &&
                selectedValue4Id !== 36 &&
                selectedValue4Id !== 40 &&
                selectedValue4Id !== 41 &&
                selectedValue4Id !== 42 && (
                  <div className="row row-sm-1 mt-4">
                    <strong className="" style={{ fontSize: "16px" }}>
                      Employee Assignment(Optional)
                    </strong>
                    <div className="col-md-12 mt-2">
                      <div className="row">
                        <div className="col-md-6">
                          <label
                            className="form-label"
                            style={{ fontSize: "12px" }}
                          >
                            Department
                          </label>
                          <ReactSelect
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            onChange={(option) => {
                              handleDepartmentAssign1(option);
                            }}
                            styles={customStyles}
                            isMulti
                            options={departmentOptions}
                          />
                        </div>
                        <div
                          className="col-md-6"
                          // style={{ minWidth: "100%" }}
                          ref={dropdownRef}
                        >
                          <label
                            className="form-label"
                            style={{ fontSize: "12px" }}
                          >
                            Employee :{" "}
                          </label>

                          <ReactSelect
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            // defaultValue={[
                            //   colourOptions[4],
                            //   colourOptions[5],
                            // ]}
                            onChange={(option) => {
                              handleCheckboxChangeAssign(option);
                            }}
                            styles={customStyles}
                            isMulti
                            options={employeeOptions}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </Box> */}
            {selectedValue4Id !== 10 &&
              selectedValue4Id !== 11 &&
              selectedValue4Id !== 19 &&
              selectedValue4Id !== 12 &&
              selectedValue4Id !== 13 &&
              selectedValue4Id !== 14 &&
              selectedValue4Id !== 18 &&
              selectedValue4Id !== 39 &&
              selectedValue4Id !== 20 &&
              selectedValue4Id !== 21 &&
              selectedValue4Id !== 23 &&
              selectedValue4Id !== 24 &&
              selectedValue4Id !== 25 &&
              selectedValue4Id !== 26 &&
              selectedValue4Id !== 29 &&
              selectedValue4Id !== 30 &&
              selectedValue4Id !== 31 &&
              selectedValue4Id !== 32 &&
              selectedValue4Id !== 35 &&
              selectedValue4Id !== 33 &&
              selectedValue4Id !== 34 &&
              selectedValue4Id !== 36 &&
              selectedValue4Id !== 40 &&
              selectedValue4Id !== 41 &&
              selectedValue4Id !== 42 && (
                <Box>
                  <CreateButton
                    type="button"
                    handleClose={handleClose}
                    handleCreateCase={handleCreateCase}
                  ></CreateButton>
                </Box>
              )}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
export default CreateTicket;
